interface awardsItem {
	link: string,
	width: string,
	height: string,
	alt: string
}

const awardsList: awardsItem[] = [
	{
		link: "/images/awards/2024-winner-csd.svg",
		width: "119px",
		height: "96px",
		alt: "2024-winner-csd"
	},
	{
		link: "/images/awards/2024-winner-ai.svg",
		width: "119px",
		height: "96px",
		alt: "2024-winner-ai"
	},
	{
		link: "/images/awards/2024-winner-react.svg",
		width: "119px",
		height: "96px",
		alt: "2024-winner-react"
	},
	{
		link: "/images/awards/2023-csd.svg",
		width: "119px",
		height: "96px",
		alt: "2023-csd"
	},
	{
		link: "/images/awards/2023-ai.svg",
		width: "119px",
		height: "96px",
		alt: "2023-ai"
	},
	{
		link: "/images/awards/2023-raect-js.svg",
		width: "119px",
		height: "96px",
		alt: "2023-raect-js"
	},
	{
		link: "/images/awards/clutch-2023-fg.svg",
		width: "119px",
		height: "96px",
		alt: "clutch-2023-fg"
	},
	{
		link: "/images/awards/clutch-2021-uae.svg",
		width: "119px",
		height: "96px",
		alt: "clutch-2021-uae"
	},
	{
		link: "/images/awards/top-software.svg",
		width: "105px",
		height: "92px",
		alt: "top-software"
	},
	{
		link: "/images/awards/gold-firms.svg",
		width: "105px",
		height: "92px",
		alt: "gold-firms"
	},
	{
		link: "/images/awards/top-artificial.svg",
		width: "107px",
		height: "92px",
		alt: "top-artificial"
	},

]

export { awardsList, awardsItem }
